<template>
  <div class="container">
      <div class="content">
        <sponsor-process ref="processForm"></sponsor-process>
        <transition name="el-fade-in">
          <div class="footer" v-show="footer" :class="[isCollapsed?'footer-collapsed':'']">
              <el-button type="info" plain  @click="back">返回</el-button>
              <el-button type="primary" plain  @click="resetForm">重置</el-button>
              <el-button type="primary"   @click="submitForm" :loading="btnLoading">提交审批</el-button>
          </div>
        </transition>
      </div>
  </div>
</template>
<script>
import SponsorProcess from "@/pages/officeApproval/sendApproval/SponsorProcess";
export default {
  name: 'sendApproval',
  components: {
      SponsorProcess
  },
  computed:{
    isCollapsed() {
        return this.$store.state.isCollapsed
    }
  },
  data() {
      return {
          btnLoading: false,
          footer:false,
          detail:{
            footer:false
          }
      }
  },
  created() {
  },
  activated() {
   this.footer =false,
     setTimeout(()=>{
        this.footer = true
      },500)
    // 每次进来要先把上次选择的用户清一下
    this.$nextTick(() => {
      this.$refs.processForm.resetProcessUser()
      
    })
  },
  beforeDestroy() {
    this.footer = false; // 页面卸载时隐藏 footer
  },
  mounted() {

  },
  methods: {
    // 返回
    back() {
      // 编辑页返回我发起的
      let type = this.$route.query.type;
      if (type==='edit') {
        localStorage.setItem('selectedMenuIndex', '/officeApproval/approvalMyList')
      }
      this.$router.go(-1)

    },
    // 重置表单
    resetForm() {
      this.$refs.processForm.resetForm();
    },
    // 发起审批
    submitForm() {
      if(this.btnLoading || this.$refs.processForm.loading || this.$refs.processForm.historyLoading)return;
      // 校验逻辑,有自选的不能为空
      let isValid = true;
      this.$refs.processForm.cc.forEach(item => {
        if (item.isEdit && (!item.users || (item.users && item.users.length === 0))) {
          this.$set(item,'isEmpty',true)
          isValid = false;
        }
      });
      if (!isValid) return false
      const formData = this.$refs.processForm.getFormData();
      const form = this.$refs.processForm.getForm();
      console.log("form111",form);
      
      const processUser = this.$refs.processForm.getProcessUser();
      const strUserInfo = sessionStorage.getItem("userInfo");
      const postData = {
        processDefinitionId: form.processDefinitionId,
        id: form.id,
        formData,
        processUsers: processUser,
        startUserInfo: JSON.parse(strUserInfo),
      }
      this.btnLoading = true;
      this.$refs.processForm.validate((valid) => {
        if (valid) {
          console.log("postData",postData.formData);
          console.info(postData.formData)
      // return false;
          this.$api.workflowStart(postData).then((res) => {
            // console.log("startProcess", res);
            if (res.code === 0) {
              this.$message.success("提交成功");
              localStorage.setItem('selectedMenuIndex', '/officeApproval/approvalMyList')
              this.$router.push({
                name: "approvalMyList",
              });
            }else if(res.message){
              this.$message.error(res.message);
            }
            this.btnLoading = false;
          }).catch(err=>{
            this.btnLoading = false;
          });
        } else {
          this.$message.warning("请完善表单");
          this.btnLoading = false;
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        min-height: calc(100vh - 202px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 26px;
        box-sizing: border-box;
        padding-bottom: 20px;
        // border-bottom: px solid #F5FAF9;
        border-radius: 8px 8px 0 0;
        position: relative;
        &::after{
          content: '';
          position: absolute;
          left: 58%;
          top: 89px;
          bottom: 16px;
          background-color: #EDF2F2;
          width: 1px;
        }
    }
    .form-search{
      padding-top:10px;
      display: flex;
      border-bottom: 1px solid #EDF2F2;
      padding-bottom: 20px;
      .label{
        width: 36px;
        flex-shrink: 0;
        font-size: 14px;
        color: #2F3030;
        line-height: 32px;
      }
      .search-input{
        width: 204px;
        margin-right: 32px;
      }
      .btn{
        margin-right: 2px;
      }
    }
    .list-dl{
      margin-left:-24px;
      .list-dt{
        height:70px;
        box-sizing: border-box;
        padding: 31px 0 0 6px;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        position: relative;
        margin-left: 24px;
        &:after{
          content: '';
          position: absolute;
          left: 0;
          top:35px;
          width: 2px;
          height: 16px;
          background: #00B498 ;
        }
      }
      .list-dd{
        display: inline-flex;
        width: 256px;
        height: 64px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #E3E6E5;
        margin-bottom:16px;
        box-sizing: border-box;
        padding-left:12px;
        line-height: 32px;
        cursor: pointer;
        margin-left:24px;
      }
      .name{
        display: inline-flex;
        align-items: center;
        color: #2F3030;
        font-size: 14px;
      }
      .icon{
        display: inline-block;
        width: 32px;
        height: 32px;
        background-image:url('~@/assets/img/icon/icon-shenpi.png');
        margin-right: 8px;
      }
    }
    .no-data-container{
      display: flex;
      min-height: calc(100vh - 300px);
    }
}
/* 底部按钮 */
.footer {
  height: 84px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 200px;
  right: 0;
  bottom: 0;
  border-top: 1px solid #EDF2F2;
  box-sizing: border-box;
  transition: left 0.3s ease-in-out;
  z-index: 2;
  .el-button {
    min-width: 88px;
    padding:12px 20px 10px;
  }

  .el-button+.el-button {
    margin-left: 16px;
  }
}

.footer-collapsed {
  left: 80px;
}
</style>
